// import React, { useState } from "react";
// import "./productCategory.scss";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { API_BASE_URL } from "../../../../utils/index";
// import Swal from "sweetalert2/dist/sweetalert2.js";
// import { useAuthHeaders } from "../../../../components/Token";
// import { POSTVendorCategory } from "../../../../services/api/Category";

// function ProductVendorCategory() {
//   const [name, setName] = useState();
//   const navigate = useNavigate();

//   const subdomain = localStorage.getItem("vendorsubdomain")

//   const handleCategoryCreation = async(e) => {
//     e.preventDefault();

//     const payload = {
//       name: name,
//     }
//     const response = await POSTVendorCategory(subdomain, payload)
//     console.log(response, ">>>>>>")
//    if(response.success){

//    }

//   };

//   const handleCancel = (e) => {
//     e.preventDefault();
//     navigate("/category");
//   };

//   return (
//     <div className="p-3">
//       <h2>Create Category</h2>
//       <form
//         action=""
//         className="category"
//         onSubmit={handleCategoryCreation}
//         style={{
//           boxShadow: "0 0 10px 0 rgba(0,0,0,0.45) inset",
//         }}
//       >
//         <div>
//           <label htmlFor="name" className="fs-6">
//             Create Category Name:
//           </label>
//           <br />
//           <input
//             type="text"
//             id="name"
//             onChange={(e) => setName(e.target.value)}
//             placeholder="Enter the Category Name"
//           />
//         </div>
//         <div className="buttons">
//           <button
//             type="submit"
//             value="send"
//             style={{ backgroundColor: "#0443C0", color: "white" }}
//           >
//             Save
//           </button>
//           <button
//             onClick={handleCancel}
//             className="cancel-btn"
//             style={{ backgroundColor: "#F04B25", color: "white" }}
//           >
//             Cancel
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// }

// export default ProductVendorCategory;
import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Snackbar,
  Alert,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { POSTVendorCategory } from "../../../../services/api/Category";
import { API_BASE_URL } from "../../../../utils/index";

function ProductVendorCategory() {
  const [name, setName] = useState("");
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const navigate = useNavigate();
  const subdomain = localStorage.getItem("vendorsubdomain");

  const handleCategoryCreation = async (e) => {
    e.preventDefault();
    try {
      const payload = { name };
      const response = await POSTVendorCategory(subdomain, payload);
      console.log(response, ">>>>>")
      if (response?.success) {
        setSnackbar({ open: true, message: response.message, severity: "success" });
        setName("");
        navigate(`/${subdomain}/master/category`)
      } else {
        setSnackbar({ open: true, message: response.data.message, severity: "error" });
        throw new Error("Failed to create category");
      }
    } catch (error) {
      console.log(error, ">>>")
      // setSnackbar({ open: true, message: error.data.message, severity: "error" });
    }
  };

  const handleCancel = () => {
    navigate(`/${subdomain}/master/category`);
  };

  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>
        Create Category
      </Typography>

      <Paper elevation={1} sx={{ p: 3, maxWidth: 500 }}>
        <form onSubmit={handleCategoryCreation}>
          <TextField
            fullWidth
            label="Category Name"
            variant="outlined"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            sx={{ mb: 3 }}
          />

          <Box display="flex" gap={2}>
            <Button type="submit" variant="contained" color="primary">
              Save
            </Button>
            <Button variant="contained" color="error" onClick={handleCancel}>
              Cancel
            </Button>
          </Box>
        </form>
      </Paper>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default ProductVendorCategory;
